import { render, staticRenderFns } from "./UploadTaxIncome.vue?vue&type=template&id=10d1e99e&"
import script from "./UploadTaxIncome.vue?vue&type=script&lang=ts&"
export * from "./UploadTaxIncome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d1e99e')) {
      api.createRecord('10d1e99e', component.options)
    } else {
      api.reload('10d1e99e', component.options)
    }
    module.hot.accept("./UploadTaxIncome.vue?vue&type=template&id=10d1e99e&", function () {
      api.rerender('10d1e99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/upload-tax-income/UploadTaxIncome.vue"
export default component.exports